// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__WLra_","emails":"CreateEditClinics_emails__3Ur7s","emailTagLabel":"CreateEditClinics_emailTagLabel__3SNwr"};